<template>
  <div>
    <BarChartContainer
      :title="translations('dashboard.gross_profit_budget_actual')"
      :month-datasets="monthDatasets"
      :year-datasets="yearDatasets"
      :chart-datalabels="chartDataLabels"
    />

    <vue-element-loading :active="isLoading" color="#888" />
  </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading'

import BarChartContainer from './BarChartContainer'
import { mapState } from 'vuex'

const BAR_THICKNESS_WIDTH = 20
const COLUMN_SPACE = 6
const MAX_BAR_THICKNESS = BAR_THICKNESS_WIDTH - COLUMN_SPACE

const config = {
  estimates: {
    label: '予算',
    color: '#FF532E'
  },
  actualProfit: {
    label: '実績',
    color: '#FEC32A'
  },
  period: {
    labels: [
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
      '1月'
    ]
  }
}

const initialMonthDatasets = (monthLength) => [
  {
    label: config.estimates.label,
    data: new Array(monthLength).fill(0),
    backgroundColor: config.estimates.color,
    barThickness: BAR_THICKNESS_WIDTH,
    maxBarThickness: MAX_BAR_THICKNESS
  },
  {
    label: config.actualProfit.label,
    data: new Array(monthLength).fill(0),
    backgroundColor: config.actualProfit.color,
    barThickness: BAR_THICKNESS_WIDTH,
    maxBarThickness: MAX_BAR_THICKNESS
  }
]

const initialYearDatasets = () => [
  {
    label: config.estimates.label,
    data: [0],
    backgroundColor: config.estimates.color
  },
  {
    label: config.actualProfit.label,
    data: [0],
    backgroundColor: config.actualProfit.color
  }
]

export default {
  name: 'ActualProfitBarChart',

  components: { BarChartContainer, VueElementLoading },

  props: {
    filterParams: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      isLoading: false,
      monthDatasets: initialMonthDatasets(),
      yearDatasets: initialYearDatasets(),
      chartDataLabels: config.period.labels,
      monthNamesEnglish: [
        'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January'
      ]
    }
  },

  created () {
    this.fetchActualProfitAndEstimate()
  },

  mounted () {
    this.fetchActualProfitAndEstimate()
  },

  watch: {
    filterParams: {
      handler: 'fetchActualProfitAndEstimate',
      deep: true
    }
  },

  computed: {
    ...mapState(['currentLanguage'])
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    mappingChartData (data) {
      const { detail = [], total = {} } = data
      const convertDetail = this.$util.convertArrayOfObjectToObject(detail, 'month')
      const keysDetail = Object.keys(convertDetail)
      const estimateData = this.monthDatasets[0].data.map((_, index) => convertDetail[keysDetail[index]] ? convertDetail[keysDetail[index]].budget : 0)
      const actualProfitData = this.monthDatasets[0].data.map((_, index) => convertDetail[keysDetail[index]] ? convertDetail[keysDetail[index]].gross_profit : 0)

      this.monthDatasets[0].data = estimateData
      this.monthDatasets[1].data = actualProfitData
      this.yearDatasets[0].data = [total.budget]
      this.yearDatasets[1].data = [total.gross_profit]
    },
    async fetchActualProfitAndEstimate () {
      try {
        this.isLoading = true
        if (this.filterParams.search) {
          const {
            data: { status, data }
          } = await this.$http.post(
            this.$api_url.progress_bar_chart_actual_profit,
            this.filterParams
          )

          if (!status) {
            // handle api error
            throw new Error('Something went wrong.')
          } else {
            this.monthDatasets = initialMonthDatasets(data.detail.length)
            this.chartDataLabels = !this.filterParams.select_filter_type ? data.detail.map(dataChart => dataChart.label) : config.period.labels
            this.mappingChartData(data)
          }
        }
      } catch (e) {
        this.monthDatasets = initialMonthDatasets(12)
        this.yearDatasets = initialYearDatasets()

        this.$toastr.error(
          'エラーのため失敗しました。ご確認後、再試行してください。',
          'エラー'
        )
      } finally {
        this.isLoading = false
      }
    },

    updateLabels () {
      this.monthDatasets = this.monthDatasets.map(dataset => ({
        ...dataset,
        label: this.translations(`dashboard.${dataset.label}`)
      }))
      this.yearDatasets = this.yearDatasets.map(dataset => ({
        ...dataset,
        label: this.translations(`dashboard.${dataset.label}`)
      }))
    }
  }
}
</script>
